module.exports = __webpack_public_path__ + "img/1_025.a4e3e283.jpg";